import React from 'react';

const Title = (props) => (
    <>
        <h1 className='text-center bg-light text-primary py-3'>{props.children}</h1>
    </>
)

export default Title